import React, { CSSProperties, ReactNode } from 'react';
import { useFetchEntity } from '../../Services/fetchApi';
import Tabs from 'react-bootstrap/Tabs'
import { Button, Container, Row, Label, Col } from 'reactstrap'
import Tab from 'react-bootstrap/Tab'
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import DataTable from '../Form/DataTable';
import { useEffect } from 'react';
import { endpoints } from '../../utils/Constants';
import { useAuth } from '../../Services/AuthContext';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';
import LoadingAnimation from '../Form/LoadingAnimation';
import { showDate, showDateUTC, showTime, showTimeUTC } from '../../utils/Helpers';
import GetRemaining from '../Editors/GetRemaining';
import JobReference from '../Editors/JobReference';
import useCheckMobileScreen from '../../utils/Hooks/useCheckMobileScreen';
import JobLookup from '../Form/JobLookup';
import Editor from '../Models/Editor';
import ManageEntityList from './ManageEntityList';
import useFetch from '../../Services/useFetch';
import moment from 'moment';
import useFetchSimple from '../../Services/useFetchSimple';
import { ICharterRequest } from '../../Models/ICharterRequest';

const TopLabel = ({ children, style }: { children?: ReactNode, style?: CSSProperties }) => <Row><Label style={{ fontSize: '10px' }} >{children}</Label></Row>

const SecondLabel = ({ children, style }: { children?: ReactNode, style?: CSSProperties }) => <Row><Label style={{ fontSize: '15px', fontFamily: 'RobotoBold', whiteSpace: 'pre-line' }} >{children}</Label></Row>

const formatDepartureForDisplay = (request: Record<string, any>) => {
    const isZoned = request?.scheduleMode === 'Zoned' && request?.departureLocalTime;
    const displayDate = isZoned ? request.departureLocalTime : request?.departTime;
    const abbreviation = isZoned && request?.departureTimeZoneAbbreviation ? ` ${request.departureTimeZoneAbbreviation}` : '';
    return <span style={{ whiteSpace: 'pre-line' }}>{showDate(displayDate) + '\n' + showTime(displayDate) + abbreviation}</span>;
}

const MobileColumn = ({ charter, route }) => {

    const history = useHistory();
    const onCharterSelect = (requestId) => {
        history.push(route + '/' + requestId);
    }

    return charter ? <Container className='p-0'>
        <Row style={{ backgroundColor: '#006CAA', color: 'white' }}>
            <Container>
                <Container>
                    <Row>
                        <Col>
                            <TopLabel>From:</TopLabel>
                            <SecondLabel>{charter.request.from}</SecondLabel>

                        </Col>

                        <img alt='>' style={{ position: 'relative', width: '50px', top: '10px', height: '50px', right: 0 }} src={"/img/pdf/white-jet.png"} />

                        <Col>
                            <TopLabel>To:</TopLabel>
                            <SecondLabel>{charter.request.to}</SecondLabel>
                        </Col>
                        <Col>
                            <TopLabel>Depart Time:</TopLabel>
                            <SecondLabel>{formatDepartureForDisplay(charter.request)}</SecondLabel>
                        </Col>
                        <Col>
                            <TopLabel>Status:</TopLabel>
                            <SecondLabel>{charter.request.status}</SecondLabel>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </Row>
        <Row>
            <Container>
                <Container>
                    <Row>
                        <Col>
                            <TopLabel>Job Ref:</TopLabel>
                            <SecondLabel>JB{charter.request.jobReference}</SecondLabel>
                        </Col>
                        <Col>
                            <TopLabel>Bids:</TopLabel>
                            <SecondLabel>{charter.request.bidCount}</SecondLabel>
                        </Col>
                        <Col>
                            <TopLabel>Remaining:</TopLabel>
                            <SecondLabel><GetRemaining fontSize={'15px'} charter={charter} /></SecondLabel>
                        </Col>
                        <Col>
                            <Container>
                                <Row>
                                    <Col style={{ padding: 0 }}>
                                        <TopLabel style={{ marginLeft: '15px' }}>Sectors:</TopLabel>
                                        <SecondLabel style={{ marginLeft: '15px' }}>{charter.routeCount}</SecondLabel>
                                    </Col>
                                    <Col>

                                    </Col>
                                </Row>

                                <Button color="primary" className='float-right' style={{ position: 'absolute', right: 0, bottom: 0, }}
                                    onClick={() => onCharterSelect(charter.id)}>View</Button>
                            </Container>

                        </Col>
                    </Row>
                </Container>
            </Container>
        </Row>
    </Container> : null
}


const CharterRequestsTabList = ({ allowedActions, item, route, headerHeight, tabItem, all, parentHeight }) => {


    const mobileColumns = [
        {
            accessor: (x) => 'JB' + x.request.jobReference,
            Cell: ({ row }) => <MobileColumn charter={row.original} route={route} />,
            Header: 'Job Reference',

        }
    ]
    const actions = [{ name: 'View', action: (row) => onCharterSelect(tabItem.changes ? row.id : row.request.id) },];
    const { activeKey } = useParams<{ activeKey?: string }>();
    const [auth] = useAuth();
    const isMobile = useCheckMobileScreen();
    const endpointAll = tabItem.changes ? tabItem.endpointChangeAll : tabItem.endpointAll;
    const endpoint = tabItem.changes ? tabItem.endpointChange : tabItem.endpoint;
    const entity = {
        ...tabItem.entity, getByStatus: () =>
            (all ? endpointAll : endpoint) +
            (tabItem.changes ?
                (activeKey ? activeKey + '/' : '') +
                (tabItem.id ? tabItem.id : '')
                : (tabItem.id ? tabItem.id + '/' : '/')
                + activeKey
            )
    }

    const columns = auth?.role === "Admin" && tabItem.confirmed ? [...tabItem.columns, {
        accessor: (x) => x.request.adminAcknowleged,
        Cell: ({ row }) => row.original.request.adminAcknowledged ? <h6>Checked</h6> : <Button onClick={() => { updateAcknowledged(row.original.request.id) }}>Check</Button>,
        Header: 'Checked',

    },] : tabItem.columns;
    const [requests, loading, error, refresh] = useFetchEntity(entity);
    const history = useHistory();
    const fetch = useFetchSimple();

    const updateAcknowledged = (id) => {
        fetch(endpoints.updateAcknowledged + id, { method: 'POST' }).then(() => {
            refresh();
        });
    };
    const onCharterSelect = (requestId) => {
        history.push(route + '/' + requestId);
    }
    const showError = (data) => {
        if (data.request.status === 'Live' && data.request.bidCount === 0) {
            const bidEnd = moment.utc(data.request.biddingEndsAt);
            const noww = moment();
            const hours = moment.duration(bidEnd.diff(noww)).asHours();
            if (hours < 24) {
                return '#f9c2c2';
            }
        }
        if (auth.role === 'Admin' && data.request.status === 'Confirmed') {
            const fin = moment.utc(data.request.finished);
            const noww = moment();
            const mins = moment.duration(noww.diff(fin)).asMinutes();
            if (mins > 5) {
                return '#def1de';
            }

            return null;
        }

        return null;
    }
    const [showPayLoadReportButton, setShowPayLoadReportButton] =React.useState(false);   
    //const [showDepatureReportButton, setShowDepartureReportButton] =React.useState(false);   

    const togglePayLoadReportButton=()=>{
        setShowPayLoadReportButton(true);
    };

    // const toggleDepatureReportButton=()=>{
    //     setShowDepartureReportButton(true);
    // };
      
    return <React.Fragment>
        <Container><Row>
            <Col md={4}><h1> {entity.plural}</h1></Col>
            {tabItem.changes ? null : <Col md={3}><JobLookup onSelect={onCharterSelect} /></Col>}
            <Col md={2}>
                    {(auth?.role === "Admin" || auth?.role?.includes("Client")) && tabItem.confirmed?<Button style={{ margin: '10px' }} onClick={() => togglePayLoadReportButton()}>Payload&nbsp;Report</Button>:null}
                    {showPayLoadReportButton ? <Editor hideSave entity={entities.payLoadReport} route={route} itemId={'1'} editorClosed={() => setShowPayLoadReportButton(false)} /> : null}                   
            </Col> 
            {/* <Col md={2}>
                    {(auth?.role === "Admin" || auth?.role?.includes("Client")) && tabItem.confirmed?<Button style={{ margin: '10px' }} onClick={() => toggleDepatureReportButton()}>Departure&nbsp;Report</Button>:null}
                    {showDepatureReportButton ? <Editor hideSave entity={entities.departureReport} route={route} itemId={'1'} editorClosed={() => setShowDepartureReportButton(false)} /> : null}                   
            </Col>             */}
           
        </Row></Container>
        {error ? <p>Error</p>
            : !error && loading ?
                <LoadingAnimation />
                : !loading && requests instanceof Array ? <DataTable
                    parentHeight={parentHeight}
                    entity={entity}
                    title={<h1>Charter Requests</h1>}
                    /*filter={({ values }: {
                        values: { id: string; Remaining: string };
                    }) => {
                        if (auth.role !== "Admin" && ["Live", "Confirmed"].includes(activeKey ?? ""))
                            return new Date(values.Remaining) >= new Date();
                        return true;
                    }}*/
                    data={requests ? requests : []}
                    heightOffset={headerHeight}
                    showBg={showError}
                    columns={!isMobile ? columns : mobileColumns}
                    actions={!isMobile ? actions : []} /> : <h3>No Charter requests in this category</h3>}

    </React.Fragment>;
}

interface CRSupplierProps {
    allowedActions?: Record<string, unknown>[];
    all?: true;
    route: string;
    tabItem: { tabs?: { route: string, name: string, className?: string }[] };
    item?: unknown;
    parentHeight?: number | string;
    headerHeight?: number;
}
const CharterRequestsSupplier = ({ allowedActions, all, route, tabItem, item, parentHeight }: CRSupplierProps) => {
    let history = useHistory();
    const { activeKey } = useParams<{ activeKey: string }>();

    const { tabs } = tabItem;
    useEffect(() => {
        if (tabs && history) {
            const requestedTab = tabs.find(x => x.route === activeKey);
            const activeTabKey = requestedTab ? requestedTab.route : tabs[0].route;
            if (activeTabKey && activeKey !== activeTabKey) {
                history.push(route + '/' + activeTabKey);
            }
        }
    }, [tabs, activeKey, history, route]);
    const setActiveTab = (tab) => {
        if (tab && activeKey !== tab) {
            history.push(route + '/' + tab);
        }
    }

    const headerHeight = 60;

    return <React.Fragment>
        <Tabs mountOnEnter activeKey={activeKey} onSelect={setActiveTab} >
            {tabs?.map((tab, i) => <Tab key={i} eventKey={tab.route} title={tab.name} tabClassName={tab.className} >
                {tabItem && activeKey === tab.route ? <CharterRequestsTabList allowedActions={allowedActions} item={item} parentHeight={parentHeight} all={all} tabItem={{ ...tabItem, ...tab }} route={route + '/' + tab.route} headerHeight={headerHeight} /> : null}
            </Tab>)}
        </Tabs>
    </React.Fragment>
}

interface TabProps {
    area: string;
    route?: string;
    item?: ICharterRequest;
    parentHeight?: number;
}

const CharterRequestsTab = ({ area, route = "", item, parentHeight }: TabProps) => {
    const { list, activeKey, clientStaffId, clientId,
        clientDepartmentId, supplierId, charterRequestId } = useParams<Record<string, string>>();
    const history = useHistory();
    const [auth] = useAuth();
    const sectorWidth = '15%';
    const jobReferenceWidth = '25%';
    const completedColumns = [
        { accessor: 'request.status', Header: 'Status', width: sectorWidth, },
        {
            accessor: (x) => 'JB' + x.request.jobReference,
            Cell: ({ row }) => <JobReference charter={row.original.request} />,
            Header: 'Job Reference',
            width: jobReferenceWidth,

        },
        {
            accessor: (x) => x.request.departTime,
            Cell: ({ row }) => { return formatDepartureForDisplay(row.original.request) },
            Header: 'Depart Time',

        },
        {
            accessor: 'request.from',
            Header: 'From',

        },
        {
            accessor: 'request.to',
            Header: 'To',

        },
        {
            accessor: 'request.routeCount',
            Header: 'Sectors',
            width: sectorWidth,

        },
        {
            accessor: 'request.bidCount',
            Header: 'Bids',
            width: sectorWidth,
        },

    ]
    const changeColumns = [{
        accessor: 'status',
        Header: 'Status',
        width: sectorWidth,
    },
    {
        accessor: (x) => 'JB' + x.request.jobReference,
        Cell: ({ row }) => <JobReference charter={row.original.request} />,
        Header: 'Job Reference',
        width: jobReferenceWidth,
    },
    {
        accessor: (x) => x.request.departTime,
        Cell: ({ row }) => { return formatDepartureForDisplay(row.original.request) },
        Header: 'Depart Time',

    },
    {
        accessor: 'request.from',
        Cell: ({ row }) => { return row.original.request.from ? row.original.request.from.toUpperCase() : "" },
        Header: 'From',

    },
    {
        accessor: 'request.to',
        Cell: ({ row }) => { return row.original.request.to ? row.original.request.to.toUpperCase() : "" },
        Header: 'To',

    },
    {
        accessor: 'request.routeCount',
        Header: 'Sectors',
        width: sectorWidth,
    },
    ];
    const liveColumns = [
        {
            accessor: 'request.status',
            Header: 'Status',
            width: sectorWidth,
        },
        {
            accessor: (x) => 'JB' + x.request.jobReference,
            Cell: ({ row }) => <JobReference bid charter={row.original.request} style={{
                width: sectorWidth
            }} />,
            Header: 'Job Reference',
            width: jobReferenceWidth,
        },
        {
            accessor: (x) => x.request.departTime,
            Cell: ({ row }) => { return formatDepartureForDisplay(row.original.request) },
            Header: 'Depart Time',

        },
        {
            accessor: 'request.from',
            Cell: ({ row }) => { return row.original.request.from ? row.original.request.from.toUpperCase() : "" },
            Header: 'From',

        },
        {
            accessor: 'request.to',
            Cell: ({ row }) => { return row.original.request.to ? row.original.request.to.toUpperCase() : "" },
            Header: 'To',

        },
        {
            accessor: (x) => x.request.biddingEndsAt,
            Cell: ({ row }) => <GetRemaining charter={row.original} />,
            Header: 'Remaining',

        },
        {
            accessor: 'request.routeCount',
            Header: 'Sectors',
            width: sectorWidth,

        },
        { accessor: 'request.bidCount', Header: 'Bids', width: sectorWidth, },

    ]


    const newColumns = [
        { accessor: 'request.status', Header: 'Status' },
        {
            accessor: (x) => 'JB' + x.request.jobReference,
            Cell: ({ row }) => <JobReference charter={row.original.request} />,
            Header: 'Job Reference',
            width: jobReferenceWidth,
        },
        {
            accessor: (x) => x.request.createdAt,
            Cell: ({ row }) => { return showDateUTC(row.original.request.createdAt) + '\n' + showTimeUTC(row.original.request.createdAt) },
            Header: 'Created At',

        },
        {
            accessor: (x) => x.request.departTime,
            Cell: ({ row }) => {
                return formatDepartureForDisplay(row.original.request)
            },
            Header: 'Depart Time',

        },
        {
            accessor: 'request.from',
            Cell: ({ row }) => { return row.original.request.from ? row.original.request.from.toUpperCase() : "" },
            Header: 'From',

        },
        {
            accessor: 'request.to',
            Cell: ({ row }) => { return row.original.request.to ? row.original.request.to.toUpperCase() : "" },
            Header: 'To',

        },
        {
            accessor: (x) => x.request.biddingEndsAt,
            Cell: ({ row }) => <GetRemaining charter={row.original} />,
            Header: 'Remaining',
            width: sectorWidth,
        },
        {
            accessor: 'request.routeCount',
            Header: 'Sectors',
            width: sectorWidth,
        },
        { accessor: 'request.bidCount', Header: 'Bids', width: sectorWidth },

    ]
    const tabs = [
        {
            route: 'Live',
            name: "Live",
            filterItems: ["Live"],
            className: 'tabBlack',
            columns: liveColumns,
            entity: entities.charterRequest,
        },
        {
            route: 'Upcoming',
            name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Confirmed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Charters</div>
                </Row>
            </Container>,
            filterItems: ["Confirmed"],
            className: 'tabGreen',
            columns: liveColumns,
            entity: entities.charterRequest,
            confirmed: true,
        },
        {
            route: 'Completed', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Completed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Charters</div>
                </Row>
            </Container>, filterItems: ["Confirmed"], className: 'tabBlack',
            columns: completedColumns,
            entity: entities.charterRequest,
        },
        {
            route: 'Closed', name: "Closed", filterItems: ["Closed"], className: 'tabBlack',
            columns: completedColumns,
            entity: entities.charterRequest,
        },
        {
            route: 'New', name: "New", filterItems: ["Pending"], className: 'tabSpaced tabRed',
            columns: newColumns,
            entity: entities.charterRequest,
        },
        {
            route: 'PendingConfirmation', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Pending</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Confirmation</div>
                </Row>
            </Container>,
            filterItems: ["PendingConfirmation"],
            className: 'tabRed',
            columns: liveColumns,
            entity: entities.charterRequest,
        },
        {
            route: 'LiveChange', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Pending</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Changes</div>
                </Row>
            </Container>,
            filterItems: ["PendingChanges"], className: 'tabRed',
            columns: changeColumns,
            entity: entities.changeCharter,
            changes: true,
        },
        {
            route: 'AllChanges', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Completed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Changes</div>
                </Row>
            </Container>,
            filterItems: ["PendingChanges"], className: 'tabRed',
            columns: changeColumns,
            entity: entities.changeCharter,
            changes: true,
        },
    ];
    const supplierTabs = [
        { route: 'Live', name: "Live", filterItems: ["Live"], className: 'tabBlack', columns: liveColumns, entity: entities.charterRequest },
        {
            route: 'Upcoming', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Confirmed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Charters</div>
                </Row>
            </Container>,
            filterItems: ["Confirmed"],
            className: 'tabGreen',
            columns: liveColumns,
            entity: entities.charterRequest,
            confirmed: true
        },
        {
            route: 'Completed', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Completed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Charters</div>
                </Row>
            </Container>,
            filterItems: ["Confirmed"],
            className: 'tabBlack',
            columns: completedColumns,
            entity: entities.charterRequest,

        },
        {
            route: 'Closed', name: "Closed", filterItems: ["Closed"], className: 'tabBlack',
            columns: completedColumns,
            entity: entities.charterRequest
        },
        {
            route: 'PendingConfirmation', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Pending</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Confirmation</div>
                </Row>
            </Container>,
            filterItems: ["PendingConfirmation"], className: 'tabRed',
            columns: liveColumns,
            entity: entities.charterRequest
        },
        {
            route: 'LiveChange', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Pending</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Changes</div>
                </Row>
            </Container>,
            filterItems: ["PendingChanges"], className: 'tabRed',
            columns: changeColumns,
            entity: entities.changeCharter,
            changes: true,
        },
        {
            route: 'AllChanges', name: <Container>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Completed</div>
                </Row>
                <Row>
                    <div style={{ alignContent: 'center', width: '100%' }}>Changes</div>
                </Row>
            </Container>,
            filterItems: ["PendingChanges"], className: 'tabRed',
            columns: changeColumns,
            entity: entities.changeCharter,
            changes: true,
        },
    ];
    const items = {
        "Admin/supplier": {
            id: supplierId,
            endpoint: endpoints.getSupplierCharterRequestsByStatus,
            endpointChange: endpoints.getSupplierChangeCharterByStatus,
            tabs: supplierTabs
        },
        "Admin/client": {
            id: clientId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointAll: endpoints.getClientAllCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointChangeAll: endpoints.getClientAllChangeCharterByStatus,
            tabs: tabs
        },
        "Admin/department": {
            id: clientDepartmentId,
            //endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpoint: endpoints.getClientDepartmentAllCharterRequestsByStatus,
            //endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointChange: endpoints.getClientDepartmentAllChangeCharterByStatus,
            tabs: tabs
        },
        "Admin/staff": {
            id: clientStaffId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointAll: endpoints.getClientDepartmentStaffAllCharterRequestsByStatus,
            endpointChangeAll: endpoints.getClientDepartmentStaffAllChangeCharterByStatus,
            tabs: tabs
        },
        "Admin/": {
            endpoint: endpoints.adminCharterRequests,
            endpointChange: endpoints.adminCharterChange,
            tabs: tabs
        },
        "Supplier/": {
            id: auth?.supplierId ? auth.supplierId : supplierId,
            endpoint: endpoints.getSupplierCharterRequestsByStatus,
            endpointChange: endpoints.getSupplierChangeCharterByStatus,
            tabs: supplierTabs
        },
        "Client/client": {
            id: auth.clientId ? auth.clientId : clientId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointAll: endpoints.getClientAllCharterRequestsByStatus,
            tabs: tabs
        },
        "Client/": {
            id: auth.clientId ? auth.clientId : clientId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointAll: endpoints.getClientAllCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointChangeAll: endpoints.getClientAllChangeCharterByStatus,
            tabs: tabs
        },
        "Client/department": {
            id: clientDepartmentId,
            //endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpoint: endpoints.getClientDepartmentAllCharterRequestsByStatus,
            //endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointChange: endpoints.getClientAllChangeCharterByStatus,
            tabs: tabs
        },
        "Client/staff": {
            id: clientStaffId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointAll: endpoints.getClientDepartmentStaffAllCharterRequestsByStatus,
            endpointChangeAll: endpoints.getClientDepartmentStaffAllChangeCharterByStatus,
            tabs: tabs
        },
        "ClientDepartment/": {
            id: auth.clientDepartmentId,
            //endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpoint: endpoints.getClientDepartmentAllCharterRequestsByStatus,
            //endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointChange: endpoints.getClientDepartmentAllChangeCharterByStatus,
            tabs: tabs
        },
        "ClientDepartment/department": {
            id: auth.clientDepartmentId,
            //endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpoint: endpoints.getClientDepartmentAllCharterRequestsByStatus,
            //endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointChange: endpoints.getClientDepartmentAllChangeCharterByStatus,
            tabs: tabs,
        },
        "ClientDepartment/staff": {
            id: clientStaffId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointAll: endpoints.getClientDepartmentStaffAllCharterRequestsByStatus,
            endpointChangeAll: endpoints.getClientDepartmentStaffAllChangeCharterByStatus,
            tabs: tabs
        },
        "ClientStaff/": {
            id: auth.clientStaffId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointAll: endpoints.getClientDepartmentStaffAllCharterRequestsByStatus,
            endpointChangeAll: endpoints.getClientDepartmentStaffAllChangeCharterByStatus,
            tabs: tabs
        },
        "ClientStaff/staff": {
            id: auth.clientStaffId,
            endpoint: endpoints.getClientOnlyCharterRequestsByStatus,
            endpointChange: endpoints.getClientOnlyChangeCharterByStatus,
            endpointAll: endpoints.getClientDepartmentStaffAllCharterRequestsByStatus,
            endpointChangeAll: endpoints.getClientDepartmentStaffAllChangeCharterByStatus,
            tabs: tabs
        },
    }

    const definition = items[auth.role + '/' + area];
    const tab = definition?.tabs ? definition?.tabs.find(x => x.route === activeKey) : null;
    const entity = tab?.entity;
    const setActiveTab = (tab) => {
        if (tab && list !== tab) {
            history.push(route + '/' + tab);
        }
    }

    const [allowedActions] = useFetch<{ actionType: string, id: string, appRoute: string, }[]>(endpoints.getActionsForEntityList + entities.charterRequest.name);

    if (!definition?.endpointAll) {
        return definition ? <React.Fragment>
            <CharterRequestsSupplier allowedActions={allowedActions} parentHeight={parentHeight ? parentHeight - 160 : undefined} item={item ? item : { id: definition.id }} tabItem={definition} route={route + "/Me"} headerHeight={160} />
            <Switch>
                {allowedActions?.map(x => x.actionType === 'ListRoute' ? <Route key={x.id} path={route + '/' + list + '/' + activeKey + '/' + x.appRoute} render={() =>
                    <Editor hideSave route={route + '/' + list + '/' + activeKey + '/' + x.appRoute} entity={entities[x.appRoute]} itemId={item!.id} newItem={entities[x.appRoute]} editorClosed={() => history.push(route)}>
                        <ManageEntityList route={route + '/' + list + '/' + activeKey + '/' + x.appRoute} entity={entities[x.appRoute]} parentHeight={400} />
                    </Editor>} /> : null)}
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list/:activeKey'}
                    render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={entity} itemParam='charterRequestId' />} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={entity} itemParam='charterRequestId' />} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={entity} itemParam='charterRequestId' />} />
            </Switch>
        </React.Fragment> : null;
    } else
        return <React.Fragment>
            <Tabs mountOnEnter activeKey={list} onSelect={setActiveTab} >
                <Tab key={"All"} eventKey={"All"} title={"All"} >
                    {definition && list !== 'Me' ? <CharterRequestsSupplier parentHeight={parentHeight ? parentHeight - 160 : undefined} all item={item ? item : { id: charterRequestId }} tabItem={definition} route={route + '/All'} headerHeight={160} /> : null}
                </Tab>
                <Tab key={"Me"} eventKey={"Me"} title={"Me"} >
                    {definition && list === 'Me' ? <CharterRequestsSupplier parentHeight={parentHeight ? parentHeight - 160 : undefined} item={item ? item : { id: charterRequestId }} tabItem={definition} route={route + '/Me'} headerHeight={160} /> : null}
                </Tab>
            </Tabs>
            <Switch>
                {allowedActions && allowedActions.map(x => x.actionType === 'ListRoute' ? <Route key={x.id} path={route + '/' + list + '/' + activeKey + '/' + x.appRoute} render={() =>
                    <Editor hideSave route={route + '/' + list + '/' + activeKey + '/' + x.appRoute} entity={entities[x.appRoute]} itemId={item!.id} newItem={entities[x.appRoute]} editorClosed={() => history.push(route)}>
                        <ManageEntityList route={route + '/' + list + '/' + activeKey + '/' + x.appRoute} entity={entities[x.appRoute]} parentHeight={400} />
                    </Editor>} /> : null)}
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list/:activeKey'} render={() =>
                    <ClientModal route={route + '/' + list + '/' + activeKey} entity={entity} itemParam='charterRequestId' />} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/:list'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={entity} itemParam='charterRequestId' />} />
                <Route path={route + '/' + list + '/' + activeKey + '/:charterRequestId/'} render={() => <ClientModal route={route + '/' + list + '/' + activeKey} entity={entity} itemParam='charterRequestId' />} />
            </Switch>
        </React.Fragment>

};

export default CharterRequestsTab;